<p-splitter [style]="{ height: '100%' }"
            [panelSizes]="[83, 17]"
            [minSizes]="[25,17]"
            stateKey="brighthub-copilot-chat-splitter"
            stateStorage="local"
            (onResizeEnd)="scrollToBottom()"
            layout="vertical"
            styleClass="chat-splitter">
  <!-- Top panel: Chat messages -->
  <ng-template #panel>
    <div #scrollPanel class="chat-scroll-container">
      <div class="chat-messages">
        @for (message of viewMessages$ | async; track message.id) {
          <lib-chat-message
            [message]="message"
            [copilotName]="copilotName"
            [userDisplayName]="message.userDisplayName"
            [userInitials]="message.userInitials"
            [hideFeedback]="forceHideInput() || forceDisableInput()"
          />
        }
        @if (showThinking$ | async) {
          <div class="relative message assistant thinking">
            <div class="flex-shrink-0 w-8 h-8 rounded-full avatar assistant">
              <img
                src="assets/copilot/brightside_bug.png"
                alt="BrightAI"
                class="w-full h-full rounded-full object-cover"
              />
            </div>
            <div class="flex gap-2 mb-1 text-xs text-gray-500 meta">
              <span class="font-semibold capitalize role">BrightAI</span>
              <span class="timestamp">now</span>
            </div>
            <div class="italic text-gray-600 thinking-dots content">
              BrightAI is thinking<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>

  <!-- Bottom panel: Suggestions row + Chat input -->
  @if (!forceHideInput()) {
    <ng-template #panel>
      @if (selectedConversationId$ | async; as selectedConversationId) {
        @if (!forceDisableInput()) {
          <div class="chat-bottom-panel">
            <lib-copilot-playbooks-panel
              [clientId]="selectedClientId() ?? null"
              [conversationId]="selectedConversationId ?? null"
              [loggedInUserId]="loggedInUserId()"
              [isStreaming]="isStreamingSignal()"
            />

            <form class="chat-input" (ngSubmit)="send()">
              <div class="chat-input-editor-row">
                <textarea
                  class="chat-textarea"
                  [ngModel]="draftText()"
                  (ngModelChange)="onDraftChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  name="copilotMessage"
                  [disabled]="forceDisableInput() || !selectedConversationId || disableInput()"
                  placeholder="Type your message..."
                  aria-label="Type your message"
                  (keydown)="handleComposerKeydown($event, selectedConversationId)"
                  (compositionstart)="onComposerCompositionStart()"
                  (compositionend)="onComposerCompositionEnd()"
                ></textarea>

                <div class="chat-send-row">
                  <p-button
                    type="submit"
                    label="Send"
                    [disabled]="forceDisableInput() || (!hasSendableContent() || !selectedConversationId || disableInput())"
                    styleClass="p-button-outlined"
                  />
                </div>
              </div>

              @if (contextChips().length > 0) {
                <div class="chat-context-tray" role="group" aria-label="Added context">
                  <div class="chat-context-tray__list">
                    @for (chip of contextChips(); track trackContextChip($index, chip)) {
                      <span class="chat-context-chip" [attr.title]="chip.label">
                        <i [class]="contextChipIcon(chip.sourceType) + ' chat-context-chip__icon'" aria-hidden="true"></i>
                        <span class="chat-context-chip__label">{{ chip.label }}</span>
                        <button
                          type="button"
                          class="chat-context-chip__remove"
                          (click)="removeContextChip(chip.id, $event)"
                          [disabled]="disableInput()"
                          [attr.aria-label]="'Remove context: ' + chip.label"
                        >
                          <i class="pi pi-times" aria-hidden="true"></i>
                        </button>
                      </span>
                    }
                  </div>
                  <span class="chat-context-tray__count">{{ contextCount() }}/{{ maxContextItems }}</span>
                </div>
              }
            </form>
          </div>
        } @else {
          <div class="flex justify-center items-center p-4">
            This conversation is archived. You cannot send messages here.
          </div>
        }
      } @else if (!forceDisableInput()) {
        <div class="chat-bottom-panel chat-bottom-panel--disabled">
          <form class="chat-input">
            <div class="chat-input-editor-row">
              <textarea
                disabled
                class="chat-textarea"
                placeholder="Select a conversation to start chatting..."
              ></textarea>
              <div class="chat-send-row">
                <p-button
                  type="button"
                  label="Send"
                  disabled
                  styleClass="p-button-outlined"
                />
              </div>
            </div>
          </form>
        </div>
      }
    </ng-template>
  }
</p-splitter>
